export { ProviderTableData } from './ProviderTableData';
